import React, { MouseEventHandler } from 'react';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import ExpandIconComponent from '../Groups/Expand-icon.component';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ListSkeletonComponent from './List-skeleton.component';
import SubuserDeviceItemComponent from './Subuser-device-item.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IDevice } from './IDevice';
import { emptyFn } from '@core/interfaces/emptyFn';

interface IProps {
    id: string;
    name: string;
    loading: boolean;
    deviceList: IDevice[];
    deviceBtnHover: boolean;
    visible: boolean;
    onAddDeviceToSubuserOpen: MouseEventHandler<HTMLElement>;
    onEditSubuserOpen: MouseEventHandler<HTMLElement>;
    onDeleteSubuserOpen: MouseEventHandler<HTMLElement>;
    onClick: MouseEventHandler<HTMLElement>;
    onEditSubuserRightsOpen: MouseEventHandler<HTMLElement>;
    onDeleteDeviceOpen: MouseEventHandler<HTMLElement>;
    onDeviceBtnHoverStart: emptyFn;
    onDeviceBtnHoverStop: emptyFn;
}

const Component: React.FC<IProps> = ({
    id,
    name,
    loading,
    deviceList,
    deviceBtnHover,
    visible,
    onAddDeviceToSubuserOpen,
    onEditSubuserOpen,
    onDeleteSubuserOpen,
    onClick,
    onEditSubuserRightsOpen,
    onDeleteDeviceOpen,
    onDeviceBtnHoverStart,
    onDeviceBtnHoverStop,
}: IProps) => {
    const getWord = useDictionary();
    const login = name;
    const length = deviceList.length;
    const getDeviceItems = ({ imei, name }: IDevice) => {
        return (
            <SubuserDeviceItemComponent
                name={name}
                imei={imei}
                key={imei}
                login={login}
                deviceBtnHover={deviceBtnHover}
                onDeviceBtnHoverStart={onDeviceBtnHoverStart}
                onDeviceBtnHoverStop={onDeviceBtnHoverStop}
                onDeleteDeviceOpen={onDeleteDeviceOpen}
                onEditSubuserRightsOpen={onEditSubuserRightsOpen}
            />
        );
    };
    let deviceItems: React.ReactElement[] = [];
    if (length > 0) {
        deviceItems = deviceList.map(getDeviceItems);
    }

    if (!loading)
        return (
            <>
                <ListItemButton
                    className="subusers__item"
                    component="li"
                    id={id}
                    onClick={onClick}
                >
                    <ListItemText
                        classes={{
                            root: 'subusers__item-text-wrap',
                            primary: 'subusers__item-text',
                        }}
                        primary={`${name} (${length})`}
                    />
                    <Tooltip
                        classes={{
                            popper: 'subusers__item-menu-tooltip-popper',
                            tooltip: 'subusers__item-menu-tooltip',
                        }}
                        title={getWord('addDeviceToSubuserAccount')}
                        placement="top"
                    >
                        <IconButton
                            className="subusers__item-menu-btn"
                            onClick={onAddDeviceToSubuserOpen}
                        >
                            <AddIcon className="subusers__item-menu-ico" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip
                        classes={{
                            popper: 'subusers__item-menu-tooltip-popper',
                            tooltip: 'subusers__item-menu-tooltip',
                        }}
                        title={getWord('changeSubuserPassword')}
                        placement="top"
                    >
                        <IconButton
                            className="subusers__item-menu-btn"
                            onClick={onEditSubuserOpen}
                        >
                            <EditIcon className="subusers__item-menu-ico" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip
                        classes={{
                            popper: 'subusers__item-menu-tooltip-popper',
                            tooltip: 'subusers__item-menu-tooltip',
                        }}
                        title={getWord('deleteSubuser')}
                        placement="top"
                    >
                        <IconButton
                            className="subusers__item-menu-btn"
                            onClick={onDeleteSubuserOpen}
                        >
                            <DeleteIcon className="subusers__item-menu-ico" />
                        </IconButton>
                    </Tooltip>
                    <ExpandIconComponent
                        devices={deviceList}
                        visible={visible}
                    />
                </ListItemButton>
                <Collapse className="devices__item" component="li" in={visible}>
                    <List className="device__list">{deviceItems}</List>
                </Collapse>
            </>
        );
    else
        return (
            <>
                <ListSkeletonComponent />
            </>
        );
};

const SubuserItemComponent = React.memo(Component);

export default SubuserItemComponent;
